import routes from '@/pages/corporate/routes';
import { GroupTypeEnum, WorkspaceSubjects } from '@/types/schema';

export const getGroupWorkspaceSubject = (type: GroupTypeEnum) => {
  switch (type) {
    case GroupTypeEnum.UserCollection: {
      return WorkspaceSubjects.UserCollection;
    }
    case GroupTypeEnum.ContentCollection: {
      return WorkspaceSubjects.ContentCollection;
    }
  }
};

export const getGroupListWorkspaceSubject = (type: GroupTypeEnum) => {
  switch (type) {
    case GroupTypeEnum.UserCollection: {
      return WorkspaceSubjects.Learner;
    }
    case GroupTypeEnum.ContentCollection: {
      return WorkspaceSubjects.Resource;
    }
  }
};

export const getGroupDetailsRoute = (type: GroupTypeEnum, id: string) => {
  switch (type) {
    case GroupTypeEnum.UserCollection: {
      return routes.GroupDetails(id);
    }
    case GroupTypeEnum.ContentCollection: {
      return routes.CollectionDetails(id);
    }
  }
};

export const getGroupEditorRoute = (type: GroupTypeEnum, id: string) => {
  switch (type) {
    case GroupTypeEnum.UserCollection: {
      return routes.GroupEditor(id);
    }
    case GroupTypeEnum.ContentCollection: {
      return routes.CollectionEditor(id);
    }
  }
};

export const getGroupManagerRoute = (type: GroupTypeEnum) => {
  switch (type) {
    case GroupTypeEnum.UserCollection: {
      return routes.GroupManager();
    }
    case GroupTypeEnum.ContentCollection: {
      return routes.CollectionManager();
    }
  }
};

export const getGroupCreatorRoute = (type: GroupTypeEnum) => {
  switch (type) {
    case GroupTypeEnum.UserCollection: {
      return routes.GroupCreator();
    }
    case GroupTypeEnum.ContentCollection: {
      return routes.CollectionCreator();
    }
  }
};
